import { SEARCH_DRAWER_TAB_PARAM_KEY } from 'components/IncidentsMap/SearchDrawer/SearchDrawer.constants';
import { PROGRESSION_MODEL_INDEX_PARAM_KEY } from 'features/wildfires/wildfire.constants';
import { MAP_MODE_PARAM_KEY } from 'hooks/useMapMode.constants';
import type { MapSearchURLParams } from 'hooks/useMapSearch';

const mapSearchURLParamKeysObj: Record<keyof MapSearchURLParams, true> = {
  search: true,
  searchType: true,
  ownership: true,
  urgency: true,
  metadata: true,
};

export const mapSearchURLParamKeys = Object.keys(
  mapSearchURLParamKeysObj,
) as (keyof MapSearchURLParams)[];

// Search params that belong to the map, not to whatever drawer is open.
// These survive navigating between map entities; everything else is dropped.
export const MAP_SEARCH_PARAM_KEYS = [
  MAP_MODE_PARAM_KEY,
  ...mapSearchURLParamKeys,
  SEARCH_DRAWER_TAB_PARAM_KEY,
  PROGRESSION_MODEL_INDEX_PARAM_KEY,
] as const;

export const pickMapSearchParams = (search: string): string => {
  const current = new URLSearchParams(search);
  const kept = new URLSearchParams();

  MAP_SEARCH_PARAM_KEYS.forEach((key) => {
    current.getAll(key).forEach((value) => kept.append(key, value));
  });

  const keptSearch = kept.toString();
  return keptSearch ? `?${keptSearch}` : '';
};
